<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">
    <section id="header">
      <h1 class="h1Header">LIQUIDACIÓN MENSAJERÍA</h1>
    </section>
    <section id="table">
      <mat-card class="mat-elevation-z0">
        <form [formGroup]="cadetesForm" (ngSubmit)="search(cadetesForm.value)">
          <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
            <div fxFlex="30">
              <mat-form-field appearance="outline">
                <mat-label>Cadete</mat-label>
                <mat-select required formControlName="cadete">
                  <mat-option *ngFor="let delivery of allDeliveries" [value]="delivery.cdDelivery">
                    {{delivery.dsName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="cadetesForm.controls['cadete']?.hasError('required')">
                  Este campo es obligatorio
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="30">
              <mat-form-field appearance="outline">
                <mat-label>Desde</mat-label>
                <input matInput [matDatepicker]="dateFrom" (dateInput)="inpuDateFrom($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateFrom></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex="30">
              <mat-form-field appearance="outline">
                <mat-label>Hasta</mat-label>
                <input matInput [matDatepicker]="dateTo" (dateInput)="inpuDateTo($event)" readonly>
                <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                <mat-datepicker #dateTo></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex="10">
              <mat-form-field appearance="outline">
                <mat-label>Nº</mat-label>
                <input matInput formControlName="number" readonly>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-flat-button class="squared-btn" type="submit">Confirmar cabecera</button>
          </div>
        </form>
        <br>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                          [checked]="selection.hasValue() && isAllSelected()"
                          [indeterminate]="selection.hasValue() && !isAllSelected()"
                          aria-label="Seleccionar todas las órdenes">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let order">
              <mat-checkbox (click)="$event.stopPropagation()"
                          (change)="$event ? toggle(order) : null"
                          [checked]="selection.isSelected(order)"
                          [aria-label]="'select ' + order.cdOrder">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="cdOrder">
            <th mat-header-cell *matHeaderCellDef class="table-header">PEDIDO</th>
            <td mat-cell *matCellDef="let order">{{ order.cdOrder }}</td>
          </ng-container>
          <ng-container matColumnDef="dtCreatedAt">
            <th mat-header-cell *matHeaderCellDef class="table-header">FECHA</th>
            <td mat-cell *matCellDef="let order">{{ order.dtCreatedAt | date: 'short' }}</td>
          </ng-container>
          <ng-container matColumnDef="dsName">
            <th mat-header-cell *matHeaderCellDef class="table-header">CLIENTE</th>
            <td mat-cell *matCellDef="let order">{{ order.dsName }}</td>
          </ng-container>
          <ng-container matColumnDef="calculatedCost">
            <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL CALCULADO</th>
            <td mat-cell *matCellDef="let order">{{ order.calculatedCost }}</td>
          </ng-container>
          <ng-container matColumnDef="finalCost">
            <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL FINAL</th>
            <td mat-cell *matCellDef="let order">{{ order.finalCost }}</td>
          </ng-container>
          <ng-container matColumnDef="finalCostWithIVA">
            <th mat-header-cell *matHeaderCellDef class="table-header">VALOR CON IVA</th>
            <td mat-cell *matCellDef="let order">{{ order.finalCostWithIVA || '-' }}</td>
          </ng-container>
          <ng-container matColumnDef="qtComisionCadete">
            <th mat-header-cell *matHeaderCellDef class="table-header">COMISIÓN CADETE</th>
            <td mat-cell *matCellDef="let order">{{ order.qtComisionCadete }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <br>
        <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
          <div fxLayout="column" fxFlex="70">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>OBSERVACIONES</mat-label>
              <textarea matInput [(ngModel)]="observaciones"></textarea>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxFlex="30">
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Total mensajería</mat-label>
              <input disabled matInput [value]="totalDelivery">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Comisión</mat-label>
              <input disabled matInput [value]="totalCommission">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Liquidación</mat-label>
              <input disabled matInput [value]="totalLiq">
            </mat-form-field>
            <mat-form-field appearance="outline" class="formField">
              <mat-label>Recibos</mat-label>
              <input disabled matInput [value]="totalReceipts">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem">
          <div fxFlex="30">
            <mat-form-field appearance="outline" class="quantity">
              <mat-label>Contraseña</mat-label>
              <input type="password" matInput required [(ngModel)]="password">
            </mat-form-field>
          </div>
          <div>
            <button mat-flat-button class="squared-btn" (click)="confirmLiquidation()">Emitir liquidación</button>
          </div>
        </div>
      </mat-card>
    </section>
  </div>